module.exports = __webpack_public_path__ + "static/electrician-builder-work-electrician-tool-1-986536d81e4f072fc2e64f9659b5b95a.png";